const adminBase = process.env.REACT_APP_API_SERVER_ADMIN || '';
const publicApiBase = (
  process.env.REACT_APP_API_SERVER_PUBLIC ||
  process.env.REACT_APP_API_SERVER_PUBILC ||
  adminBase.replace(/\/admin\/?$/, '/')
).trim().replace(/\/?$/, '/');

export const Config = {
  API_SERVER: process.env.REACT_APP_API_SERVER,
  /** 공개 공통코드 GET /api/code/detail — NG11·NG02·NG14, main 가입·비로그인 전용 */
  API_CODE_DETAIL:
    process.env.REACT_APP_API_CODE_DETAIL || `${publicApiBase}code/detail`,
  /** 공개 사업자등록상태 조회 POST /api/biz-validation/status — 국세청 API를 백엔드가 대행 호출 */
  API_BIZ_VALIDATION_STATUS:
    process.env.REACT_APP_API_BIZ_VALIDATION_STATUS ||
    `${publicApiBase}biz-validation/status`,
  /** 공개 진행중 이벤트 조회 GET /api/event/active — 현장 룰렛 전용, 비로그인 */
  API_EVENT_ACTIVE:
    process.env.REACT_APP_API_EVENT_ACTIVE || `${publicApiBase}event/active`,
  /** 공개 룰렛 추첨 POST /api/event/draw — 현장 룰렛 전용, 비로그인 */
  API_EVENT_DRAW:
    process.env.REACT_APP_API_EVENT_DRAW || `${publicApiBase}event/draw`,
  /** @deprecated 조회는 API_CODE_DETAIL 사용. operator CRUD 전용 base */
  API_SERVER_OPERATOR:
    process.env.REACT_APP_API_SERVER_OPERATOR ||
    adminBase.replace(/\/admin\/?$/, '/operator/'),
  SHOPADMIN_SERVER: process.env.REACT_APP_SHOPADMIN_SERVER,
  SHOPUSER_SERVER: process.env.REACT_APP_SHOPUSER_SERVER,
  MAIN_SERVER: process.env.REACT_APP_MAIN_SERVER,
  /** 메인(www) 도메인 — 미설정(로컬) 시 상대경로 '/' */
  SHOPMAIN_SERVER: (process.env.REACT_APP_SHOPMAIN_SERVER || '/')
    .trim()
    .replace(/\/?$/, '/'),
  // ADDRESS_SRC: '/t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js',
  PAGE_SIZE_LIST: [10, 50, 100, 200],
  PB_VALUES: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  PB_INTERVAL: 300, // PGOGRESSBAR INTERVAL (1000=1초)
  // BOARD_SECTION: {CODE: {ALL:'all', NOTICE: 'BD01', NEWS: 'BD02', BD03: 'question'},
  //                 TITLE: {ALL:'전체', NOTICE: '공지사항', NEWS: '최신뉴스', QUESTION: '자주묻는질문'}},
  // TAG_SECTION: {CODE: {ALL:'all', TG01: 'TG01', TG02: 'TG02', TG03: 'TG03', TG04: 'TG04', TG05: 'TG05', TG06: 'TG06'},
  //                 TITLE: {ALL:'전체', TG01: '복권구매', TG02: '이용안내', TG03: '캐시', TG04: '마일리지/포인트/쿠폰',
  //                  TG05: '당첨금', TG06: '기타'}},
  GAME_SECTION: {
    CODE: { POWERBALL: 'LT01', MEGAMILLION: 'LT02' },
    TITLE: { POWERBALL: '파워볼', MEGAMILLION: '메가밀리언' },
  },
  USER_SECTION: {
    CODE: {
      ALL: 'all',
      ID: 'id',
      NAME: 'name',
      MOBILE: 'mobile',
      EMAIL: 'email',
    },
    TITLE: {
      ALL: '전체',
      ID: 'ID',
      NAME: '이름',
      MOBILE: '전화번호',
      EMAIL: 'E-Mail',
    },
  },
};
